import { DateFormat, TimeFormat } from '../enums';

export const DEFAULT_DATE_FORMAT = DateFormat.dd_Mmm_YYYY;
// export const DATE_NUMERICAL_FORMAT = DateFormat.dd_MM_YYYY;
export const DATE_FILTER_FORMAT = 'dd/MM/yyyy';

export const DATE_PLACEHOLDERS: { [key in DateFormat]: string } = {
  [DateFormat.dd_Mmm_YYYY]: 'DD-MMM-YYYY',
  [DateFormat.DMY_DASH]: 'DD-MM-YYYY',
  [DateFormat.YMD_DASH]: 'YYYY-MM-DD',
  [DateFormat.DMY_DOT]: 'DD.MM.YYYY',
  [DateFormat.MDY_SLASH]: 'MM/DD/YYYY',
};

export const DATE_FNS_FORMAT: { [key in DateFormat]: string } = {
  [DateFormat.dd_Mmm_YYYY]: 'dd-LLL-yyyy',
  [DateFormat.DMY_DASH]: 'dd-LL-yyyy',
  [DateFormat.YMD_DASH]: 'yyyy-LL-dd',
  [DateFormat.DMY_DOT]: 'dd.LL.yyyy',
  [DateFormat.MDY_SLASH]: 'LL/dd/yyyy',
};

export const USER_PROFILE_TIME_FORMAT: { [key in TimeFormat]: string } = {
  [TimeFormat.HH_MM]: 'HH:mm',
  [TimeFormat.HH_MM_AM]: 'hh:mm a',
};
